import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'df-full-list-loader',
  templateUrl: './full-list-loader.component.html',
  styleUrls: ['./full-list-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FullListLoaderComponent {}
